<template>
    <div class="product-creator flex justify-center items-center w-full max-w-screen-xl h-full mx-auto px-6 py-12">
        <div class="w-full lg:w-2/3 grid grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-16">

            <div v-for="shape in shapes" :key="shape.key">
                <div class="border-4 border-dashed border-gray-200 rounded-lg mb-8 mt-8 lg:mt-0">
                    <div class="h-48 flex items-center justify-center font-bold text-2xl">Billede</div>
                </div>
                <div class="mb-12 text-center">{{ shape.text }}</div>
                <Button class="w-full" @click="select(shape.key)">
                    {{ __('home::orders.select') }} 
                    <ChevronRightIcon class="h-4 w-4 ml-2" />
                </Button>
            </div>

        </div>    
    </div>
</template>

<script>
    import axios from 'axios'
    import collect from 'collect.js'
    
    import {
        ChevronRightIcon,
    } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            shape: String,
            order: Object,
        },
        data() {
            return {
                shapes: [
                    {
                        key: 'hexagon',
                        text: 'Hexagon',
                        image: '',
                    },
                    {
                        key: 'circle',
                        text: 'Circle',
                        image: '',
                    },
                    {
                        key: 'square',
                        text: 'Square',
                        image: '',
                    },
                ],
            }
        },
        methods: {
            select(shape) {
                let request = {
                    shape: shape,
                };

                axios
                    .patch(this.$route('home::orders.update', { uuid: this.order.uuid }), request)
                    .then((res) => {
                        this.$emit('update:shape', shape);
                    });
            },
        },
    }
</script>